import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("d2-container", {
    staticClass: "release"
  }, [_c("div", {
    staticClass: "user section"
  }, [_c("div", {
    staticClass: "section-header"
  }, [_vm._v("用户基本信息")]), _c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("用户头像")]), _c("div", {
    staticClass: "value"
  }, [_c("wlc-upload-image", {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      url: _vm.form.avatar,
      preview: true,
      random: true,
      multimediaType: "userProfilePic"
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.form, "avatar", $event);
      }
    }
  }), _vm._l(_vm.form.album, function (img, index) {
    return _c("div", {
      directives: [{
        name: "dragging",
        rawName: "v-dragging",
        value: {
          item: img,
          list: _vm.form.album,
          group: "img"
        },
        expression: "{\n                            item: img,\n                            list: form.album,\n                            group: 'img',\n                        }"
      }],
      key: img,
      staticClass: "image-item",
      style: {
        "background-image": "url(" + img + "?imageView2/0/w/400/h/300|imageMogr2/auto-orient)"
      },
      on: {
        click: function click($event) {
          return _vm.previewImage(index);
        }
      }
    }, [_c("div", {
      staticClass: "icon-group"
    }, [_c("i", {
      staticClass: "fa fa-eye",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.previewImage(index);
        }
      }
    }), _c("i", {
      staticClass: "fa fa-repeat",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.selectRotateImg(index);
        }
      }
    }), _c("i", {
      staticClass: "fa fa-close",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.removeImgae(index);
        }
      }
    })])]);
  }), _c("wlc-upload-image", {
    attrs: {
      url: _vm.form.url,
      visible: false,
      multimediaType: "userProfilePic"
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.form, "url", $event);
      }
    }
  })], 2)]), _c("el-row", {
    staticClass: "mtb20",
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("姓名")]), _c("div", {
    staticClass: "value"
  }, [_c("el-input", {
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1)])]), _c("el-col", {
    attrs: {
      span: 16
    }
  }, [_c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "label label-auto"
  }, [_vm._v("性别")]), _c("div", {
    staticClass: "value"
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.gender,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "gender", $$v);
      },
      expression: "form.gender"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: "1"
    }
  }, [_vm._v("男")]), _c("el-radio-button", {
    attrs: {
      label: "2"
    }
  }, [_vm._v("女")])], 1)], 1)])])], 1), _c("el-row", {
    staticClass: "mtb20",
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("职业")]), _c("div", {
    staticClass: "value"
  }, [_c("el-input", {
    model: {
      value: _vm.form.occupation,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "occupation", $$v);
      },
      expression: "form.occupation"
    }
  })], 1)])]), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "label label-auto"
  }, [_vm._v("年龄")]), _c("div", {
    staticClass: "value"
  }, [_c("el-input", {
    model: {
      value: _vm.form.age,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "age", $$v);
      },
      expression: "form.age"
    }
  })], 1)])]), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "label label-auto"
  }, [_vm._v("来自")]), _c("div", {
    staticClass: "value"
  }, [_c("el-input", {
    model: {
      value: _vm.form.from,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "from", $$v);
      },
      expression: "form.from"
    }
  })], 1)])])], 1), _c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("个人说明")]), _c("div", {
    staticClass: "value"
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      autosize: ""
    },
    model: {
      value: _vm.form.introduce,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "introduce", $$v);
      },
      expression: "form.introduce"
    }
  })], 1)])], 1), _c("div", {
    staticClass: "tags section"
  }, [_c("div", {
    staticClass: "section-header"
  }, [_vm._v("标签")]), _c("div", {
    staticClass: "form-item mtb20"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("语言")]), _c("div", {
    staticClass: "value"
  }, _vm._l(_vm.form.language, function (item, index) {
    return _c("el-tag", {
      key: item.id,
      attrs: {
        type: item.isSelected ? "" : "info",
        closable: item.isUserAdd == 1 ? true : false,
        "data-index": index
      },
      on: {
        close: function close($event) {
          return _vm.removeTag(_vm.form.language, index);
        },
        click: function click($event) {
          return _vm.selectTag(item);
        }
      }
    }, [_vm._v(_vm._s(item.name) + " ")]);
  }), 1)]), _c("div", {
    staticClass: "form-item mtb20"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("个人标签")]), _c("div", {
    staticClass: "value"
  }, _vm._l(_vm.form.tags, function (item, index) {
    return _c("el-tag", {
      key: item.id,
      attrs: {
        type: item.isSelected ? "" : "info",
        closable: item.isUserAdd == 1 ? true : false,
        "data-index": index
      },
      on: {
        close: function close($event) {
          return _vm.removeTag(_vm.form.tags, index);
        },
        click: function click($event) {
          return _vm.selectTag(item);
        }
      }
    }, [_vm._v(_vm._s(item.name) + " ")]);
  }), 1)]), _c("div", {
    staticClass: "form-item mtb20"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("运动")]), _c("div", {
    staticClass: "value"
  }, _vm._l(_vm.form.motion, function (item, index) {
    return _c("el-tag", {
      key: item.id,
      attrs: {
        type: item.isSelected ? "" : "info",
        closable: item.isUserAdd == 1 ? true : false,
        "data-index": index
      },
      on: {
        close: function close($event) {
          return _vm.removeTag(_vm.form.motion, index);
        },
        click: function click($event) {
          return _vm.selectTag(item);
        }
      }
    }, [_vm._v(_vm._s(item.name) + " ")]);
  }), 1)]), _c("div", {
    staticClass: "form-item mtb20"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("美食")]), _c("div", {
    staticClass: "value"
  }, _vm._l(_vm.form.cate, function (item, index) {
    return _c("el-tag", {
      key: item.id,
      attrs: {
        type: item.isSelected ? "" : "info",
        closable: item.isUserAdd == 1 ? true : false,
        "data-index": index
      },
      on: {
        close: function close($event) {
          return _vm.removeTag(_vm.form.cate, index);
        },
        click: function click($event) {
          return _vm.selectTag(item);
        }
      }
    }, [_vm._v(_vm._s(item.name) + " ")]);
  }), 1)]), _c("div", {
    staticClass: "form-item mtb20"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("阅读")]), _c("div", {
    staticClass: "value"
  }, _vm._l(_vm.form.reading, function (item, index) {
    return _c("el-tag", {
      key: item.id,
      attrs: {
        type: item.isSelected ? "" : "info",
        closable: item.isUserAdd == 1 ? true : false,
        "data-index": index
      },
      on: {
        close: function close($event) {
          return _vm.removeTag(_vm.form.reading, index);
        },
        click: function click($event) {
          return _vm.selectTag(item);
        }
      }
    }, [_vm._v(_vm._s(item.name) + " ")]);
  }), 1)]), _c("div", {
    staticClass: "form-item mtb20"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("足迹")]), _c("div", {
    staticClass: "value"
  }, _vm._l(_vm.form.footprint, function (item, index) {
    return _c("el-tag", {
      key: item.id,
      attrs: {
        type: item.isSelected ? "" : "info",
        closable: item.isUserAdd == 1 ? true : false,
        "data-index": index
      },
      on: {
        close: function close($event) {
          return _vm.removeTag(_vm.form.footprint, index);
        },
        click: function click($event) {
          return _vm.selectTag(item);
        }
      }
    }, [_vm._v(_vm._s(item.name) + " ")]);
  }), 1)]), _c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("与TA分享")]), _c("div", {
    staticClass: "value"
  }, _vm._l(_vm.form.share, function (item, index) {
    return _c("el-tag", {
      key: item.id,
      attrs: {
        type: item.isSelected ? "" : "info",
        closable: item.isUserAdd == 1 ? true : false,
        "data-index": index
      },
      on: {
        close: function close($event) {
          return _vm.removeTag(_vm.form.share, index);
        },
        click: function click($event) {
          return _vm.selectTag(item);
        }
      }
    }, [_vm._v(_vm._s(item.name) + " ")]);
  }), 1)])]), _c("div", {
    staticClass: "release-btn"
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("保存")])], 1)]), _c("el-dialog", {
    staticClass: "wlc-image-preview",
    attrs: {
      top: "5vh",
      fullscreen: true,
      visible: _vm.previewDialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.previewDialogVisible = $event;
      }
    }
  }, [_c("el-carousel", {
    ref: "carousel",
    attrs: {
      "indicator-position": "none",
      autoplay: false,
      arrow: "always"
    }
  }, _vm._l(_vm.form.album, function (item) {
    return _c("el-carousel-item", {
      key: item
    }, [_c("img", {
      staticStyle: {
        width: "100%",
        height: "100%",
        "object-fit": "contain"
      },
      attrs: {
        src: item
      }
    })]);
  }), 1)], 1), _vm.imageRotateDialogVisible ? _c("wlc-image-rotate", {
    attrs: {
      url: _vm.imageRotateUrl
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };